<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

const goBack = () => {
    router.back();
};
</script>

<template>
    <v-container class="d-flex flex-column align-center justify-center fill-height">
        <h1 class="text-h1 font-weight-bold text-grey-darken-1">404</h1>
        <p class="text-h6 text-grey-darken-1 mb-6">ページが見つかりません</p>
        <v-btn color="primary" variant="outlined" @click="goBack"> 前のページに戻る </v-btn>
    </v-container>
</template>
